// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"6e7be33d","467":"37ab4060","555":"37ab4060"}[chunkId] + ".chunk.css";
};